import { render, staticRenderFns } from "./AdmissionConfirmation.vue?vue&type=template&id=3add2ce7"
import script from "./AdmissionConfirmation.vue?vue&type=script&lang=js"
export * from "./AdmissionConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports